<template>
    <rkm-form
        ref="RkmForm"
        show-legend
    >
        <rkm-overlay :show="loading">
            <rkm-row>
                <rkm-col>
                    <rkm-form-radio-group
                        label="Tipo de envio"
                        v-model="model.tipo_envio_id"
                    >
                        <rkm-form-radio :value="enums.TipoEnvio.MANUAL">Manual</rkm-form-radio>
                        <rkm-form-radio :value="enums.TipoEnvio.INCONSISTENCIA">Inconsistência</rkm-form-radio>
                        <rkm-form-radio :value="enums.TipoEnvio.CADASTRO_DESATUALIZADO">Cadastros desatualizados</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="model.tipo_envio_id === enums.TipoEnvio.MANUAL">
                <rkm-col>
                    <rkm-form-input-autocomplete
                        :fields="fields.cidadao"
                        :repository="repositories.cadastro.cidadao"
                        :validations="validations.cidadao_id"
                        label="Cidadão"
                        v-model="model.cidadao_id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="model.tipo_envio_id === enums.TipoEnvio.INCONSISTENCIA">
                <rkm-col>
                    <rkm-form-radio-group
                        :validations="validations.inconsistencia_id"
                        label="Tipo de Inconsistência"
                        v-model="model.inconsistencia_id"
                    >
                        <rkm-form-radio :value="enums.Inconsistencia.CPF">CPF</rkm-form-radio>
                        <rkm-form-radio :value="enums.Inconsistencia.NIS">NIS</rkm-form-radio>
                        <rkm-form-radio :value="enums.Inconsistencia.NOME_MAE">Nome da mãe</rkm-form-radio>
                        <rkm-form-radio :value="enums.Inconsistencia.TITULO_ELEITOR">Título de eleitor</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="model.tipo_envio_id === enums.TipoEnvio.INCONSISTENCIA || model.tipo_envio_id === enums.TipoEnvio.CADASTRO_DESATUALIZADO">
                <rkm-col>
                    <rkm-form-radio-group
                        :validations="validations.grupo_envio_id"
                        label="Grupo de envio"
                        v-model="model.grupo_envio_id"
                    >
                        <rkm-form-radio :value="enums.GrupoEnvio.TODOS">Todos</rkm-form-radio>
                        <rkm-form-radio :value="enums.GrupoEnvio.BAIRRO">Bairro</rkm-form-radio>
                        <rkm-form-radio :value="enums.GrupoEnvio.FAIXA_ETARIA">Faixa etária</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="model.grupo_envio_id === 2">
                <rkm-col>
                    <rkm-form-input-autocomplete
                        :fields="fields.bairro"
                        :repository="repositories.cadastro.bairro"
                        :validations="validations.bairro_id"
                        label="Bairro"
                        v-model="model.bairro_id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="model.grupo_envio_id === 3">
                <rkm-col>
                    <rkm-form-select
                        :validations="validations.faixa_etaria_id"
                        label="Faixa etária"
                        show-default-option
                        v-model="model.faixa_etaria_id"
                    >
                        <rkm-form-select-option
                            v-if="model.inconsistencia_id !== enums.Inconsistencia.TITULO_ELEITOR"
                            :value="1"
                        >
                            0 a 16 anos
                        </rkm-form-select-option>

                        <rkm-form-select-option :value="2">17 a 30 anos</rkm-form-select-option>
                        <rkm-form-select-option :value="3">31 a 40 anos</rkm-form-select-option>
                        <rkm-form-select-option :value="4">41 a 50 anos</rkm-form-select-option>
                        <rkm-form-select-option :value="5">51 a 59 anos</rkm-form-select-option>
                        <rkm-form-select-option :value="6">60 ou mais</rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        :validations="validations.mensagem"
                        label="Mensagem"
                        v-model="model.mensagem"
                        rows="3"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-overlay>
    </rkm-form>
</template>

<script>
// Enums.
import {
    FaixaEtaria,
    GrupoEnvio,
    Inconsistencia,
    TipoEnvio,
} from '@/enums'

// Mixins.
import {error} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        fields() {
            return {
                bairro: [
                    { key: 'nome', name: 'cadastro_bairro.nome' },
                ],
                cidadao: [
                    { key: 'nome', name: 'cadastro_cidadao.nome' },
                ],
            }
        },
        loading() {
            return this.getLoading('administracao-envio-sms-form')
        },
        validations() {
            return {
                inconsistencia_id: {required: true},
                grupo_envio_id: {required: true},
                bairro_id: {required: true},
                faixa_etaria_id: {required: true},
                cidadao_id: {required: true},
                mensagem: {
                    required: true,
                    min: 3,
                    max: 500,
                },
            }
        },
    },
    data: () => ({
        enums: {
            FaixaEtaria,
            GrupoEnvio,
            Inconsistencia,
            TipoEnvio,
        },
        model: {
            tipo_envio_id: 1,
            inconsistencia_id: null,
            grupo_envio_id: 1,
            bairro_id: null,
            faixa_etaria_id: null,
            cidadao_id: null,
            mensagem: null,
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        save() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated) {
                        this.setLoading('administracao-envio-sms-form')

                        this.repositories.administracao.envioSms.store(this.model)
                            .then(({ data }) => this.$emit('save', data))
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading('administracao-envio-sms-form'))
                    }
                })
        },
    },
    mixins: [error],
    props: {
        id: {type: Number},
    },
    watch: {
        'model.tipo_envio_id'() {
            this.model.inconsistencia_id = null
            this.model.grupo_envio_id = this.enums.GrupoEnvio.TODOS
            this.model.bairro_id = null
            this.model.faixa_etaria_id = null
        },
        'model.inconsistencia_id'() {
            this.model.grupo_envio_id = this.enums.GrupoEnvio.TODOS
            this.model.bairro_id = null
            this.model.faixa_etaria_id = null
        },
    }
}
</script>